export default __webpack_public_path__ + "resources/icons/d111-eebc.webp";